import Advocate from '../_img/cards/v2/Advocate.png'
import Captain from '../_img/cards/v2/Captain.png'
import Chameleon from '../_img/cards/v2/Chameleon.png'
import Champion from '../_img/cards/v2/Champion.png'
import Closer from '../_img/cards/v2/Closer.png'
import Consultant from '../_img/cards/v2/Consultant.png'
import Counselor from '../_img/cards/v2/Counselor.png'
import Diplomat from '../_img/cards/v2/Diplomat.png'
import Entrepreneur from '../_img/cards/v2/Entrepreneur.png'
import General from '../_img/cards/v2/General.png'
import Guardian from '../_img/cards/v2/Guardian.png'
import Interpreter from '../_img/cards/v2/Interpreter.png'
import Mercenary from '../_img/cards/v2/Mercenary.png'
import Navigator from '../_img/cards/v2/Navigator.png'
import Negotiator from '../_img/cards/v2/Negotiator.png'
import Pioneer from '../_img/cards/v2/Pioneer.png'
import Playmaker from '../_img/cards/v2/Playmaker.png'
import Promoter from '../_img/cards/v2/Promoter.png'
import Scholar from '../_img/cards/v2/Scholar.png'
import Scientist from '../_img/cards/v2/Scientist.png'
import Strategist from '../_img/cards/v2/Strategist.png'
import Striver from '../_img/cards/v2/Striver.png'

const Cards = {
    Scholar,
    Advocate,
    Scientist,
    Strategist,
    Captain,
    Chameleon,
    Closer,
    Consultant,
    Counselor,
    Champion,
    Entrepreneur,
    Interpreter,
    General,
    Playmaker,
    Pioneer,
    Striver,
    Mercenary,
    Promoter,
    Negotiator,
    Diplomat,
    Navigator,
    Guardian
}

export default Cards;